<template>
  <div class="container">
    <section class="w1380">
      <nav>当前位置：首页 > <span>文章</span> > 文章详情</nav>
      <div class="main flex">
        <markdown :source="detail"></markdown>
      </div>
    </section>
  </div>
</template>

<script>
import Markdown from "vue-markdown";
export default {
  components: {
    Markdown,
  },
  name: "HomeDetail",
  data() {
    return {
      loading: false,
      sid: "",
      detail: null,
    };
  },
  mounted() {
    this.sid = this.$route.query.sid;
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.loading = true;
      this.$http({
        url: "api/v1/discipline/link?sid=" + this.sid,
        method: "GET",
      }).then(res => {
        this.loading = false;
        this.detail = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: calc(100vh - 138px);
  .w1380 {
    width: 1380px;
    margin: 0 auto;
    nav {
      padding: 20px 0;
      font-size: 14px;
      color: #999999;
    }
    .main {
      margin-bottom: 30px;
      .info-left {
        flex: 1;
        min-width: 0;
        background: #fff;
        padding: 30px;
        color: #666666;
        .info-loading {
          min-height: 300px;
        }
      }
      .info {
        h2 {
          color: #333;
          font-weight: normal;
          font-size: 24px;
          margin-bottom: 10px;
          label {
            font-size: 14px;
            padding-left: 5px;
            width: 60px;
            line-height: 22px;
            text-align: center;
            color: white;
            font-weight: initial;
            padding: 2px 5px;
            margin-left: 5px;
          }
        }
        .titleCn {
          font-size: 18px;
        }
        .journal_span {
          label {
            cursor: pointer;
            &:hover {
              text-decoration: underline;
            }
          }
        }
        .keyword_span {
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
        .green {
          color: #2d8cf0;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
        .hover_a {
          cursor: pointer;
          text-decoration: none;
          &:hover {
            text-decoration: underline;
          }
        }
        .more-a {
          cursor: pointer;
        }
        .info-author {
          label {
            margin-right: 5px;
          }

          .span-content {
            position: relative;
            .author-content {
              top: 30px;
              left: 0px;
            }
          }
          .green_span {
            cursor: pointer;
            &:hover {
              .span_a {
                text-decoration: underline;
              }
              transition: all 1s;
              .author-content {
                display: inline-block;
              }
            }
            .span_a {
              color: #2d8cf0;
            }
          }
          .author-content {
            position: absolute;
            background: #fff;
            box-shadow: 0 0 5px #d3d3d3;
            display: none;
            padding: 10px;
            z-index: 999999;
            top: -30px;
            right: -210px;
            min-width: 300px;
            .mb10 {
              font-size: 16px;
              margin-bottom: 10px !important;
            }
            .hui {
              margin-top: 5px !important;
              white-space: pre-wrap;
            }
            p {
              font-size: 14px;
              margin: 0 !important;
              line-height: 20px;
              span {
                position: relative;
                &:first-of-type {
                  margin-right: 14px;
                  &::before {
                    content: "";
                    position: absolute;
                    width: 1px;
                    height: 14px;
                    background: #ccc;
                    right: -7px;
                    top: 50%;
                    margin-top: -7px;
                  }
                }
                label {
                  color: #2d8cf0;
                }
              }
            }
          }
        }
        p {
          font-size: 16px;
          line-height: 30px;
          a {
            text-decoration: underline;
          }
        }
        .fanyi {
          color: #2d8cf0;
          .el-button {
            font-size: 16px;
          }
        }
        .btnList {
          margin-top: 20px;
          i {
            margin-right: 5px;
          }
        }
      }
      .relative {
        position: relative;
        .rotating-image {
          animation: rotate 1s linear infinite;
        }
        @keyframes rotate {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      }
      .achieve {
        background: #ffffff;
        border-radius: 2px;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.2);
        position: absolute;
        top: 45px;
        right: 0;
        z-index: 99999;
        cursor: text;
        &::after {
          content: "";
          position: absolute;
          top: -6px;
          right: 10px;
          width: 0;
          height: 0;
          border-left: 8px solid transparent;
          border-right: 8px solid transparent;
          border-bottom: 10px solid #fff; /* 三角形的颜色 */
        }
        .achieve-li {
          min-width: 270px;
          max-width: 700px;
          overflow-y: auto;
          max-height: 200px;
          padding: 15px 20px;
        }

        li {
          font-size: 16px;
          line-height: 28px;
          padding: 0px;
          border-bottom: 0px;
          a {
            text-decoration: underline;
            color: #2d8cf0;
            cursor: pointer;
          }
          span {
            font-size: 14px;
            color: #b3b3b3;
            margin-left: 5px;
          }
          font {
            color: #b3b3b3;
            font-size: 12px;
            display: block;
            line-height: 20px;
            i {
              margin-right: 5px;
              color: #e6a23c;
            }
          }
          .el-icon-warning {
            color: #e6a23c;
            padding: 0px 10px;
            width: 30px;
          }
        }
      }
      .btnList {
        margin-top: 20px;
        background: #f7f7f7;
        height: 50px;
        line-height: 50px;
        display: flex;
        align-items: center;
        padding: 0 30px;
        .flex {
          display: flex;
          align-items: center;
          margin-left: 30px;
          cursor: pointer;
          img {
            margin-right: 5px;
          }
        }
        span {
          color: #2d8cf0;
          margin-left: 5px;
        }
        .btn-right {
          margin-left: auto;
          display: flex;
          align-items: center;
          .checked {
            color: #2d8cf0;
          }
          .pdf_img {
            width: 16px;
            height: 16px;
          }
          .noCourse {
            cursor: default !important;
          }
        }
      }
      .line {
        height: 1px;
        width: 100%;
        background: #e6e6e6;
        margin-top: 30px;
      }
      .referenceWork {
        background: #fff;
        margin-top: 20px;
        padding: 30px;
        color: #666;
        h3 {
          color: #333;
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          span {
            font-size: 15px;
            margin-left: 5px;
          }
        }
        ul {
          li {
            margin-bottom: 10px;
            cursor: pointer;
            &:hover {
              color: #2d8cf0;
            }
            &:last-of-type {
              margin: 0;
            }
          }
        }
        .more {
          margin-top: 20px;
          i {
            margin-right: 5px;
          }
        }
      }
      .tab-content {
        background: #f7f7f7;
        margin-top: 30px;
        padding: 0 30px;
        color: #333;
        .tabs {
          padding: 20px 0;
          border-bottom: 1px solid #eee;
          font-weight: bold;
          display: flex;
          li {
            margin-right: 20px;
            cursor: pointer;
          }
          .checked {
            color: #2d8cf0;
          }
        }
        .displayItem {
          display: flex;
          flex-wrap: wrap;
          li {
            display: flex;
            align-items: center;
            padding: 10px 0px;
            width: 33.33%;
            cursor: pointer;
            color: #666;
            font-size: 16px;
            a {
              text-decoration: underline;
              color: #2d8cf0;
              cursor: pointer;
            }
            span {
              font-size: 14px;
              color: #b3b3b3;
            }
            .el-icon-warning {
              color: #e6a23c;
              padding: 0px 10px;
              width: 30px;
            }
          }
          img {
            width: 18px;
            margin-right: 5px;
          }
        }
      }
      .atlasTree {
        padding: 20px;
      }
      .noData {
        min-height: 200px;
        background: none;
      }
      .wx-content {
        border-top: 1px solid #eeeeee;
        margin-top: 30px;
        padding-top: 30px;
        .tabs {
          display: flex;
          background: #f7f7f7;
          padding: 15px 30px;
          li {
            cursor: pointer;
            color: #333;
            font-weight: bold;
            margin-right: 30px;
          }
          .checked {
            position: relative;
            color: #2d8cf0;
            &::before {
              content: "";
              position: absolute;
              bottom: -15px;
              width: 100%;
              height: 2px;
              background: #2d8cf0;
              border-radius: 5px;
            }
          }
        }
        // 文献网络
        .relation-one {
          margin-top: 40px;
          text-align: center;
          .noCursor {
            cursor: default !important;
          }
          .checked {
            color: #2d8cf0;
          }
          div {
            margin-bottom: 30px;
            position: relative;
            .zuojiantou {
              width: 116px;
              height: 49px;
              position: absolute;
              left: 325px;
              top: 13px;
            }
            .youjiantou {
              width: 115px;
              height: 46px;
              position: absolute;
              right: 325px;
              top: -23px;
            }
          }
          .flex {
            align-items: center;
            justify-content: center;
            color: #333;
            span {
              background: #f0f7f7;

              &:nth-of-type(3) {
                background: #b8eaeb;
              }
            }
          }
          span {
            display: inline-block;
            text-align: center;
            width: 160px;
            height: 40px;
            line-height: 40px;
            border: 1px dashed #c2e8e8;
            cursor: pointer;
          }
          img {
            margin: 0 10px;
            width: 30px;
            height: 8px;
          }
          .cheng {
            background: #fcf4ed;
            border: 1px dashed #fcf4ed;
          }
        }
        .wx-loading {
          min-height: 250px;
        }
        .relation-two {
          margin-top: 40px;
        }
        .relation-three {
          color: #333;
          margin-top: 40px;
          h3 {
            font-size: 16px;
            margin-bottom: 10px;
          }

          li {
            padding: 20px;
            border-bottom: 1px dashed #ededed;
            &:hover {
              background: rgba(21, 186, 188, 0.04);
            }
            p {
              margin-bottom: 15px;
              &:nth-of-type(1) {
                cursor: pointer;

                &:hover {
                  background-image: linear-gradient(to right, #006eb3, #2d8cf0);
                  background-clip: text;
                  -webkit-background-clip: text;
                  -webkit-text-fill-color: transparent;
                }
              }
              &:nth-of-type(2) {
                color: #666;
              }
            }
            .num {
              color: #999;
              font-size: 14px;
              span {
                margin-right: 30px;
              }
              label {
                color: #2d8cf0;
              }
            }
          }
          .more {
            color: #2d8cf0;
            padding-left: 20px;
            font-weight: normal;
          }
          .span-content {
            position: relative;
            .author-content {
              top: 30px;
              left: 0px;
            }
          }
          .digestLabel {
            cursor: pointer;
            margin-left: 10px;
            &:hover {
              color: #2d8cf0;
            }
          }
          .green_span {
            cursor: pointer;
            &:hover {
              .span_a {
                text-decoration: underline;
              }
              transition: all 1s;
              .author-content {
                display: inline-block;
              }
            }
            .span_a {
              color: #2d8cf0;
            }
          }
          .author-content {
            position: absolute;
            background: #fff;
            box-shadow: 0 0 5px #d3d3d3;
            display: none;
            padding: 10px;
            z-index: 999999;
            top: -30px;
            right: -210px;
            min-width: 300px;
            .mb10 {
              font-size: 16px;
              margin-bottom: 10px !important;
            }
            .hui {
              margin-top: 5px !important;
              white-space: pre-wrap;
            }
            p {
              font-size: 14px;
              margin: 0 !important;
              line-height: 20px;
              span {
                position: relative;
                &:first-of-type {
                  margin-right: 14px;
                  &::before {
                    content: "";
                    position: absolute;
                    width: 1px;
                    height: 14px;
                    background: #ccc;
                    right: -7px;
                    top: 50%;
                    margin-top: -7px;
                  }
                }
                label {
                  color: #2d8cf0;
                }
              }
            }
          }
        }

        .noData {
          min-height: 200px;
        }
        .more {
          color: #2d8cf0;
          margin-top: 15px;
          cursor: pointer;
          padding-left: 30px;
        }
      }
      .info-right-loading {
        min-height: 300px;
        width: 240px;
        background: #eeeeee;
      }

      .info-right {
        background: #eeeeee;
        width: 240px;
        padding: 30px;
        font-size: 14px;
        .mt10 {
          margin-top: 20px;
          margin-bottom: 10px !important;
        }
        .name {
          color: #666666;
          font-size: 14px;
          font-weight: bold;
          margin-bottom: 20px;
        }
        .title {
          margin-bottom: 10px;
          margin-top: 10px;
          color: #333;
          cursor: pointer;
        }
        p {
          color: #666;
          margin-bottom: 5px;
        }
        .img {
          width: 180px;
          height: 180px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          background: #fff;
          margin-right: 20px;
          img {
            max-width: 178px;
            max-height: 178px;
          }
        }
        .topic {
          li {
            color: #666666;
            margin-bottom: 10px;
            cursor: pointer;
            text-decoration: underline;
            &:hover {
              color: #2d8cf0;
            }
          }
        }
      }
    }
  }
  ::v-deep .el-dialog__header {
    background: #2d8cf0;
    height: 46px;
    line-height: 46px;
    padding: 0;
    padding-left: 30px;
    font-size: 18px;
    .el-dialog__title {
      color: #fff;
    }
    .el-dialog__headerbtn {
      right: 15px;
      top: 12px;
      .el-dialog__close {
        color: #fff;
        font-size: 16px;
      }
    }
  }
  ::v-deep .el-dialog__footer {
    text-align: left;
    padding-top: 0;
    padding-bottom: 30px;
    .down-dialog-footer {
      span {
        width: 80px;
        height: 30px;
        display: inline-block;
        text-align: center;
        line-height: 30px;
        margin-left: 10px;
        cursor: pointer;
        background: #f0f7f7;
        color: #2d8cf0;
        &:hover {
          background: #2d8cf0;
          color: #fff;
        }
      }
    }
  }
  .add_folder_dialog {
    ::v-deep .dialog-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      p {
        padding-left: 20px;
        cursor: pointer;
        i {
          margin-right: 5px;
        }
      }
    }
  }
  .dialog-content {
    .dialog-tab {
      display: flex;
      align-items: center;
      font-weight: bold;
      color: #333;
      border-bottom: 1px solid #e6e6e6;
      li {
        padding-right: 10px;
        position: relative;
        padding: 0 10px;
        padding-bottom: 5px;
        cursor: pointer;
      }
      .dialogChecked {
        color: #2d8cf0;
        &::before {
          content: "";
          position: absolute;
          bottom: -1px;
          left: 0;
          height: 2px;
          background: #2d8cf0;
          width: 100%;
        }
      }
    }
    .tab1 {
      margin-top: 20px;
      ul {
        max-height: 500px;
        overflow: auto;
        li {
          background: #f7f7f7;
          padding: 30px;
          margin-bottom: 10px;
          &:last-of-type {
            margin: 0;
          }
        }
      }
      ::-webkit-scrollbar {
        display: block;
        width: 8px; /* 定制滚动条的宽度 */
      }
      /* 定制滚动条滑块样式 */
      ::-webkit-scrollbar-thumb {
        background-color: #d9d9d9;
      }
      ::-webkit-scrollbar-track {
        background-color: #f2f2f2; /* 设置滑块以外区域的背景颜色 */
      }

      .flex {
        align-items: center;

        span {
          margin-left: auto;
          cursor: pointer;
          display: flex;
          align-items: center;
          color: #2d8cf0;
        }
      }
      .line {
        border-bottom: 1px solid #e6e6e6;
        padding-bottom: 20px;
        label {
          color: #333;
          font-weight: bold;
        }
      }
      img {
        width: 17px;
        height: 16px;
        margin-right: 5px;
      }
      .dialog-info {
        color: #333333;
        line-height: 30px;
        margin-top: 20px;
        font-size: 16px;
        white-space: pre-wrap;
      }
    }
  }
  .helpDialog {
    ::v-deep .el-dialog__footer {
      text-align: right;
    }
  }
  .tipsDialog {
    font-size: 15px;
    p {
      margin-bottom: 10px;
    }
  }
}
</style>
<style lang="scss">
.tool_box {
  color: #333;
  .tool_site {
    span {
      color: #2d8cf0;
    }
  }
  .tool_click {
    color: #2d8cf0;
    cursor: pointer;
  }
}
.add_dialog_folder {
  max-height: 400px;
  overflow-y: auto;
  ul {
    li {
      cursor: pointer;
      color: #333;
      .div_folder {
        height: 40px;
        border-radius: 5px;
        display: flex;
        padding: 0 20px;
        align-items: center;
      }
      .li_folder {
        justify-content: space-between;
        border: 1px solid #fff;
      }
      .new_folder {
        border: 1px solid #2d8cf0;
        .el-input {
          .el-input__inner {
            border: none;
            background: none;
            height: 25px;
            color: #333;
            padding: 0;
          }
        }
        span {
          width: 24px;
          height: 24px;
          line-height: 24px;
          text-align: center;
          display: inline-block;
          font-size: 16px;
          margin-left: 10px;
          i {
            color: #868686;
          }
        }
      }
      &:hover {
        background: #f5f6f7;
      }
      img {
        margin-right: 10px;
      }
      i {
        color: #2d8cf0;
        font-size: 18px;
      }
    }
  }
  .new_folder {
    ::v-deep .el-input__inner {
      /* 样式 */
      border: none !important;
      background: none;
      height: 25px;
      color: #333;
      padding: 0;
    }
  }
}
</style>
